import React, { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import MyTable from './MyTable';

const API_BASE_URL = "http://192.168.2.2:89/research-api/api/v1";
const USER_NAME = "derivium";
const PASSWORD = "khZjT%67m0z";

const items = [
  {
    key: '1',
    label: 'SWAPS',
    children: <MyTable />,
  },
  {
    key: '2',
    label: 'COMMERCIAL PAPERS',
    children: <MyTable />,
  },
];
const CollapseTable = () => {

    const [items, setItems] = useState([]);

    const onChange = (key) => {
        console.log(key);
    };

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/product/mapping`, {
          method: "GET",
          headers: {
            Authorization: "Basic " + btoa(`${USER_NAME}:${PASSWORD}`)
          }
        });
        const responseData = await response.json();
        console.log(responseData);
        setItems(responseData.data.map(item => ({
            key: item.parent_product_id,
            label: item.parent_product_name,
            children: <MyTable />,
        })));
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return <Collapse 
            items={items} 
            defaultActiveKey={['1']} 
            onChange={onChange} 
            style={{width: '90%', margin: 'auto', marginTop: '5rem'}}
        />;
};
export default CollapseTable;